import React from 'react';


const Loader = () => {
  return (<>
    <div className="loaderContent">
      <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
      </div>
    </div>
  </>);
};

export default Loader;
